module.exports = __webpack_public_path__ + "img/icon2.ce6c285f.svg";